import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';
import { IntegrationActionStatus } from '@shared-features/enums/integration-action-status.enum';

export class ShipmentIntegrationActionLog extends Model {
  @Expose() createdAt: Date;
  @Expose() latestStatus: IntegrationActionStatus;
}
